module.exports = __webpack_public_path__ + "media/images/payments/alipay-dark-4d3de2f9f4ace61d3fe90b4784bc1d1f.svg";